import { gql } from '@apollo/client';

export const GET_OATT_CUSTOMERS = gql`
  query GetOattCustomers {
    oattCustomers {
      customer_id
      customer_code
      company_name
    }
  }
`;